import ShipType from "@/model/ShipType";
import IceClassType from "@/model/IceClassType";
import Configuration from "./Configuration";
import Crane from "./Crane";
import CarbonElementType from "./CarbonElementType";

class Ship {
    public id: string = ""
    public imo: string = ""
    public name: string = ""
    public requiredEEXI: number = 0
    public attainedEEXI: string = ""
    public shipType: ShipType = new ShipType()
    public shipTypeStr: string = ""
    public iceClassType: IceClassType = new IceClassType();

    public keelLaidDownDate: Date = new Date()
    public contractSignInDate: Date = new Date()
    public shipDeliveredDate: Date = new Date()
    
    public gt: number = 0
    public dwt: number = 0
    public lpp: number = 0
    public loa: number = 0
    public cb: number = 0
    public manualVref: number = 0
    public speedPowerTests: boolean = false
    public dwtsService: number = 0
    public psService: number = 0
    public vsService: number = 0
    public bs: number = 0
    public ds: number = 0

    public displacementVolume: number = 0

    public has_vse: boolean = false
    public lwtReferenceDesign: number = 0
    public lwtEnhancedDesign: number = 0
    public capacity: number = 0
    public capacityCorrection: number = 0

    public cranes: Array<Crane> = []

    public has_sideloaders: boolean = false
    public capacityNoSideloaders: number = 0
    public capacitySideloaders: number = 0

    public has_roro_ramps: boolean = false
    public capacityNoRORORamp: number = 0
    public capacityRORORamp: number = 0

    public structuralEnhancement: boolean = false
    
    public has_csr: boolean = false
    public lwtCsr: number = 0
    public dwtCsr: number = 0

    public vTanks: number = 0
    
    public fc: number = 0
    public fi_csr: number = 0
    public fi_ice: number = 0
    public fi_vse: number = 0

    public highSpeedCruise: boolean = false

    public configurations: Array<Configuration> = new Array<Configuration>()

    public carbonData: CarbonElementType = new CarbonElementType()
}

export default Ship